import { JSGraph as OriginalJSGraph } from 'common-spectrum';

import { getAnnotations } from './jsgraph/getAnnotations.js';

export {
  AnalysesManager,
  Analysis,
  fromJcamp,
  peakPicking,
  toJcamp,
} from 'common-spectrum';

export { autoPeakPicking } from './autoPeakPicking.js';

export * from './from/fromPanalytical.js';

export { references } from './references.js';

export const JSGraph = { ...OriginalJSGraph, getAnnotations };
